import React, { useState, useEffect } from 'react';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ViewListIcon from '@material-ui/icons/ViewList';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import AddTrade from '../LeftMenu/AddTrade';
import history from '../../services/history';
import { useStyles } from './BottomMenuStyles';

export default function Header() {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  useEffect(() => {
    switch (window.location.pathname) {
      case '/':
        setValue(0);
        return;
      case '/history':
        setValue(1);
        return;
      case '/depositsAndWithdraws':
        setValue(3);
        return;
      case '/insights':
        setValue(4);
        return;
      default:
        setValue(0);
        break;
    }
  }, []);

  function handleMenuChange(newValue: number) {
    switch (newValue) {
      case 0:
        history.push('/');
        return;
      case 1:
        history.push('/history');
        return;
      case 3:
        history.push('/depositsAndWithdraws');
        return;
      case 4:
        history.push('/insights');
        return;
      case 5:
        window.open(
          'https://api.whatsapp.com/send?phone=5548998155545',
          '_blank'
        );
        return;
      default:
        history.push('/');
        setValue(0);
        break;
    }
  }

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        if (newValue === 2) return;
        setValue(newValue === 6 ? value : newValue);
        handleMenuChange(newValue);
      }}
      className={classes.root}
    >
      <BottomNavigationAction label="Início" icon={<HomeIcon />} />
      <BottomNavigationAction label="Histórico" icon={<ViewListIcon />} />
      <BottomNavigationAction
        style={{ paddingTop: '5px' }}
        icon={<AddTrade />}
        component={'div' as any}
      />
      <BottomNavigationAction
        label="Depo/Reti"
        icon={<SwapHorizontalCircleIcon />}
      />
      <BottomNavigationAction label="Insights" icon={<WbIncandescentIcon />} />
      <BottomNavigationAction label="Suporte" icon={<WhatsAppIcon />} />
    </BottomNavigation>
  );
}
